export default __webpack_public_path__ + "static/media/noti-3.f2651d13.mp3";